module.exports = __webpack_public_path__ + "img/i_mytown_r.09b1bfb1.svg";